import { CompleteDE, createNetworkQuality, DownloadFinalDE, MeasurementMode, ModemDE, NetworkQualitySDK, NQValueDE, PingDE, PrepareResultDE, UploadFinalDE } from "@visonum/network-quality-sdk";
import { NQRecord, NQHint } from "@visonum/network-quality-sdk";
import { Observable, zipWith, map, Subscriber, shareReplay, EMPTY } from "rxjs";
import { logger } from "./helper/logger";
import packageInfo from '../package.json';
import { CalcDownloadRequestModel, CalcUploadRequestModel } from "@visonum/network-quality-sdk/dist/generated/openapi";

export class NetworkQualitySdkPacer extends NetworkQualitySDK {
  private networkQualitySDK: NetworkQualitySDK;

  private observable: Observable<void>;
  private trigger?: Subscriber<void>;

  public nqValues: Observable<NQValueDE> = EMPTY;

  constructor(mode: MeasurementMode) {
    super();

    logger.debug(`NetworkQualitySdkPacer constructor. Mode = ${mode}`);

    this.networkQualitySDK = createNetworkQuality(mode, "", "", {
      clientBundleId: packageInfo.name,
      clientVersion: packageInfo.version,
      logger,
    });

    logger.debug(`NetworkQualitySdkPacer constructor. networkQualitySDK = ${this.networkQualitySDK}`);

    this.observable = new Observable((observer) => {
      this.trigger = observer;
    });
  }

  public next(): void {
    this.trigger?.next();
  }

  public unsubscribe(): void {
    logger.info("pacer unsubscribe");
    this.trigger?.unsubscribe();
  }

  public speedtest(): Observable<NQValueDE> {
    logger.debug("speedtest invoked!");

    this.nqValues = this.networkQualitySDK.speedtest()
      .pipe(
        zipWith(this.observable),
        map((v: any[]) => v[0]),
        shareReplay()
      );

    return this.nqValues;
  }

  public prepare(): Observable<PrepareResultDE> {
    return this.networkQualitySDK.prepare();
  }

  public calcDownload(data: CalcDownloadRequestModel): Observable<DownloadFinalDE> {
    return this.networkQualitySDK.calcDownload(data);
  }

  public calcUpload(data: CalcUploadRequestModel): Observable<UploadFinalDE> {
    return this.networkQualitySDK.calcUpload(data);
  }

  public ping(prepareResult: PrepareResultDE): Observable<PingDE> {
    return this.networkQualitySDK.ping(prepareResult);
  }

  public complete(prepareResult: PrepareResultDE): Observable<CompleteDE> {
    return this.networkQualitySDK.complete(prepareResult);
  }

  public abort(prepareResult: PrepareResultDE): Observable<never> {
    return this.networkQualitySDK.abort(prepareResult);
  }

  public modem(prepareResult: PrepareResultDE): Observable<ModemDE> {
    return this.networkQualitySDK.modem(prepareResult);
  }

  public history(): Observable<NQRecord[]> {
    return this.networkQualitySDK.history();
  }

  public historyDeleteRecord(speedtestId: string): void {
    this.networkQualitySDK.historyDeleteRecord(speedtestId);
  }

  public historyDeleteAll(): void {
    this.networkQualitySDK.historyDeleteAll();
  }

  public hints(speedtestId?: string): Observable<NQHint[]> {
    return this.networkQualitySDK.hints(speedtestId);
  }
}